import { useLang } from '@/i18n';

interface IExtraField {
    type: string;
    name: string;
    defaultValue?: string;
    data?: any[];
}
interface IEmailMap {
    [key: string]:
        | {
              type: 'klaviyo';
              list_id: string;
              source: string;
              consent_form_id: string;
              popupBtnLink: string;
              SmartDevices?: string;
          }
        | {
              type: 'mailchimp';
              action: string;
              extraFields?: IExtraField[];
              popupBtnLink: string;
          };
}

interface TimeFormat {
    d: boolean;
    h: boolean;
    m?: boolean;
    s?: boolean;
}
interface YoutubeParams {
    img?: string;
    startTime?: string;
    liveTime?: string;
    format?: TimeFormat;
    liveContext?: string;
}

// 生产环境用
const POWER_TIME_LINE_PROD: any = {
    de: {
        teaser: '2023/05/15 14:59:55 GMT+8',
        detail: '2023/05/31 14:59:58 GMT+8',
    },
    fr: {
        teaser: '2023/05/15 14:59:55 GMT+8',
        detail: '2023/05/31 14:59:58 GMT+8',
    },
    it: {
        teaser: '2023/05/15 14:59:55 GMT+8',
        detail: '2023/05/31 14:59:58 GMT+8',
    },
    es: {
        teaser: '2023/05/15 14:59:55 GMT+8',
        detail: '2023/05/31 14:59:58 GMT+8',
    },
    eu: {
        teaser: '2023/05/15 14:59:55 GMT+8',
        detail: '2023/05/31 14:59:58 GMT+8',
    },
    uk: {
        teaser: '2023/05/15 14:59:55 GMT+8',
        detail: '2023/05/31 14:59:58 GMT+8',
    },
};

// 测试环境用
const POWER_TIME_LINE_TEST: any = {
    de: {
        teaser: '2023/05/15 14:59:55 GMT+8',
        detail: '2023/05/31 14:59:58 GMT+8',
    },
    fr: {
        teaser: '2023/05/15 14:59:55 GMT+8',
        detail: '2023/05/31 14:59:58 GMT+8',
    },
    it: {
        teaser: '2023/05/15 14:59:55 GMT+8',
        detail: '2023/05/31 14:59:58 GMT+8',
    },
    es: {
        teaser: '2023/05/15 14:59:55 GMT+8',
        detail: '2023/05/31 14:59:58 GMT+8',
    },
    eu: {
        teaser: '2023/05/15 14:59:55 GMT+8',
        detail: '2023/05/31 14:59:58 GMT+8',
    },
    uk: {
        teaser: '2023/05/15 14:59:55 GMT+8',
        detail: '2023/05/31 14:59:58 GMT+8',
    },
};

export const SHOW_COUNT_DOWN = '2023/05/28 14:59:58 GMT+8';

export const getProductTimeline = (locale: string, flag?: boolean) => {
    return flag ? POWER_TIME_LINE_TEST[locale] || POWER_TIME_LINE_TEST.us : POWER_TIME_LINE_PROD[locale] || POWER_TIME_LINE_PROD.us;
};

export const enum STAGES {
    TEASER,
    DETAIL,
    UNKNOWN,
}

export const YOUTUBE_PARAMS: YoutubeParams = {
    // img: '/media/delta/pc/1_main.jpg',
    startTime: '2023/04/08 20:00:00 GMT+8',
    liveTime: 'teaser.sec6_youtube_start_time',
    format: { d: true, h: true } as TimeFormat,
    liveContext: 'teaser.sec6_live_context',
};

export const detailYoutubeMap: any = {
    us: 'https://www.youtube.com/embed/vbIWNvkncE8',
    de: 'https://www.youtube.com/embed/4J9vTqyYRUE',
    fr: 'https://www.youtube.com/embed/xtE3XEPif6Q',
    it: 'https://www.youtube.com/embed/jtGOxYNH73s',
    es: 'https://www.youtube.com/embed/Pm78Cu_3-w0',
    cn: {
        SD: 'https://videos.ecoflow.com/414f233a732c497093a5ed9078c8eaad/8f00178764e54bc8b1913a8feff387d5-82da21de793746b6cea1259b31025f34-fd.mp4',
        HD: 'https://videos.ecoflow.com/414f233a732c497093a5ed9078c8eaad/8f00178764e54bc8b1913a8feff387d5-98ded41e8586415eb0a4f1e5ddd5561f-sd.mp4',
        '2K': 'https://videos.ecoflow.com/original/workflow/470d945a-1833b7e52ca-0004-9c91-e6d-40030.mp4',
    },
};

export const getTCBlade = (locale: string) => {
    const map: any = {
        us: {
            title: 'crowdfunding.header.terms.title',
            desc: 'crowdfunding.header.terms.desc_blade',
            links: ['https://www.youtube.com/@EcoFlowTech', 'https://www.facebook.com/ecoflowtech', 'https://www.instagram.com/ecoflowtech/'],
        },
        ca: {
            title: 'crowdfunding.header.terms.title',
            desc: 'crowdfunding.header.terms.desc_blade',
            links: ['https://www.youtube.com/@EcoFlowTech', 'https://www.facebook.com/ecoflowtech', 'https://www.instagram.com/ecoflowtech/'],
        },
    };
    return map[locale] || map.us;
};

// 产品详情页参数
export const PRODUCT_KEY = 'PowerStream';
export const GENERAL_KEY = 'product_home_wn';

// 允许访问的地区 EU/UK/DE/FR/IT/ES
export const PRODUCT_ONLINE_LOCAL = ['eu', 'de', 'fr', 'it', 'es'];
// export const PRODUCT_ONLINE_LOCAL = ['eu', 'uk', 'de', 'fr', 'it', 'es'];

export const TIME_ONE_SECOND_FIX = 1180;

export const liveVideoMap: any = {
    uk: 'https://www.youtube.com/embed/B-3OgdLhzTw',
    de: 'https://www.youtube.com/embed/iVxnCkMkQZg',
    // cn: {
    //     SD: 'https://videos.ecoflow.com/414f233a732c497093a5ed9078c8eaad/8f00178764e54bc8b1913a8feff387d5-82da21de793746b6cea1259b31025f34-fd.mp4',
    //     HD: 'https://videos.ecoflow.com/414f233a732c497093a5ed9078c8eaad/8f00178764e54bc8b1913a8feff387d5-98ded41e8586415eb0a4f1e5ddd5561f-sd.mp4',
    //     '2K': 'https://videos.ecoflow.com/original/workflow/470d945a-1833b7e52ca-0004-9c91-e6d-40030.mp4',
    // },
};

export const globalPopupLang = {
    uk: {
        activity_modal_title: 'PowerStream\nBalcony Solar System ',
        activity_modal_desc: 'launches \non 31 May',
        activity_modal_btn: 'Learn More',
    },
    eu: {
        activity_modal_title: 'PowerStream\nBalcony Solar System ',
        activity_modal_desc: 'launches \non 31 May',
        activity_modal_btn: 'Learn More',
    },
    de: {
        activity_modal_title: 'PowerStream Balkonkraftwerk',
        activity_modal_desc: 'Kommt \nam 31. Mai',
        activity_modal_btn: 'Mehr erfahren',
    },
    fr: {
        activity_modal_title: 'PowerStream\nKit solaire pour balcon',
        activity_modal_desc: 'Lancement le 31 mai',
        activity_modal_btn: 'En savoir plus',
    },
    it: {
        activity_modal_title: 'Impianto Fotovoltaico da\nBalcone EcoFlow PowerStream',
        activity_modal_desc: 'sarà lanciato il 31 maggio!',
        activity_modal_btn: 'Per saperne di più',
    },
    es: {
        activity_modal_title: 'Kit solar para balcones\nEcoFlow PowerStream ',
        activity_modal_desc: 'se lanza el 31 de mayo',
        activity_modal_btn: 'Más Información',
    },
};

export const powerStreamImgMap = {
    uk: ['sectionC-uk.webp', 'sectionC-uk.jpg'],
    eu: ['sectionC.webp', 'sectionC.jpg'],
};

export const solutionSwiperData = (locale: string) => {
    const { t } = useLang('powerstream.detail.solution');
    const worksLinkMap: any = {
        1: {
            eu: 'https://eu.ecoflow.com/pages/powerstream?diy-purchase-option=feature-bundle&micro-inverter=46777234358615&bundle=advanced-kit',
            uk: 'https://uk.ecoflow.com/pages/powerstream?diy-purchase-option=feature-bundle&micro-inverter= 46662362431827&bundle=advanced-kit',
            de: 'https://de.ecoflow.com/pages/powerstream?diy-purchase-option=feature-bundle&micro-inverter=46535891485007&bundle=advanced-kit',
            fr: {
                link: 'https://fr.ecoflow.com/pages/powerstream?diy-purchase-option=feature-bundle&micro-inverter=46535891517775&bundle=advanced-kit',
                variantId: '47173872648539',
                productId: '8589955826011',
            },
            it: 'https://it.ecoflow.com/pages/powerstream?diy-purchase-option=feature-bundle&micro-inverter=46861707215197&bundle=advanced-kit',
            es: 'https://es.ecoflow.com/pages/powerstream?diy-purchase-option=feature-bundle&micro-inverter=46779778564443&bundle=advanced-kit',
        },
        2: {
            eu: 'https://eu.ecoflow.com/pages/powerstream?diy-purchase-option=feature-bundle&micro-inverter=46777234358615&bundle=starter-kit',
            uk: 'https://uk.ecoflow.com/pages/powerstream?diy-purchase-option=feature-bundle&micro-inverter= 46662362431827&bundle=starter-kit',
            de: 'https://de.ecoflow.com/pages/powerstream?diy-purchase-option=feature-bundle&micro-inverter=46535891485007&bundle=starter-kit',
            fr: {
                link: 'https://fr.ecoflow.com/pages/powerstream?diy-purchase-option=feature-bundle&micro-inverter=46535891517775&bundle=starter-kit',
                variantId: '47173873566043',
                productId: '8589956055387',
            },
            it: 'https://it.ecoflow.com/pages/powerstream?diy-purchase-option=feature-bundle&micro-inverter=46861707215197&bundle=starter-kit',
            es: 'https://es.ecoflow.com/pages/powerstream?diy-purchase-option=feature-bundle&micro-inverter=46779778564443&bundle=starter-kit',
        },
        3: {
            eu: 'https://eu.ecoflow.com/pages/powerstream?diy-purchase-option=feature-bundle&micro-inverter=46777234358615&bundle=battery-ready',
            uk: 'https://uk.ecoflow.com/pages/powerstream?diy-purchase-option=feature-bundle&micro-inverter= 46662362431827&bundle=battery-ready',
            de: 'https://de.ecoflow.com/pages/powerstream?diy-purchase-option=feature-bundle&micro-inverter=46535891485007&bundle=battery-ready',
            fr: {
                link: 'https://fr.ecoflow.com/pages/powerstream?diy-purchase-option=feature-bundle&micro-inverter=46535891517775&bundle=battery-ready',
                variantId: '47173874876763',
                productId: '8589956317531',
            },
            it: 'https://it.ecoflow.com/pages/powerstream?diy-purchase-option=feature-bundle&micro-inverter=46861707215197&bundle=battery-ready',
            es: 'https://es.ecoflow.com/pages/powerstream?diy-purchase-option=feature-bundle&micro-inverter=46779778564443&bundle=battery-ready',
        },
    };
    const imgLocale = ['uk'].includes(locale) ? locale : 'eu';
    const data = [];
    for (let i = 1; i < 4; i++) {
        data.push({
            title: `title${i}`,
            desc: t(`desc${i}`),
            price: t(`price${i}`),
            oldPrice: t(`old_price${i}`),
            src: [`solution_${imgLocale}_${i}.webp`, `solution_${imgLocale}_${i}.png`],
            shopifyLink: typeof worksLinkMap[i][locale] === 'string' ? worksLinkMap[i][locale] : worksLinkMap[i][locale]?.link,
            variantId: typeof worksLinkMap[i][locale] === 'string' ? undefined : worksLinkMap[i][locale]?.variantId,
            productId: typeof worksLinkMap[i][locale] === 'string' ? undefined : worksLinkMap[i][locale]?.productId,
        });
    }
    return data;
};

export const worksSwiperData = (locale: string) => {
    const { t } = useLang('powerstream.detail.works');
    // const imgLocale = ['uk', 'de', 'fr', 'it', 'es', 'eu'].includes(locale) ? locale : 'uk';
    const imgLocale = ['uk'].includes(locale) ? locale : 'eu';
    const data = [];
    // 隐藏river2 https://ecoflow.feishu.cn/sheets/LoYssW37yhYWfgt5n7lcUnTSnfg?sheet=649b4f
    for (let i = 7; i > 3; i--) {
        data.push({
            product: t(`product${i}`),
            battery: t(`battery${i}`),
            surge: t(`surge${i}`),
            capacity: t(`capacity${i}`),
            src: [`works_${imgLocale}_${i}.webp`, `works_${imgLocale}_${i}.jpg`],
        });
    }
    return data;
};

export const diyShopifyLinkMap = {
    eu: 'https://eu.ecoflow.com/pages/powerstream?diy-purchase-option=diy',
    uk: 'https://uk.ecoflow.com/pages/powerstream?diy-purchase-option=diy',
    de: 'https://de.ecoflow.com/pages/powerstream?diy-purchase-option=diy',
    fr: 'https://fr.ecoflow.com/pages/powerstream?diy-purchase-option=diy',
    it: 'https://it.ecoflow.com/pages/powerstream?diy-purchase-option=diy',
    es: 'https://es.ecoflow.com/pages/powerstream?diy-purchase-option=diy',
};

export const positionMap: any = {
    uk: [
        {
            key: 'no_waste',
            name: 'no-waste',
        },
        {
            key: 'app_control',
            name: 'app-control',
        },
        {
            key: 'day_and_night',
            name: 'day-and-night',
        },
        {
            key: 'diy_install',
            name: 'diy-install',
        },
        {
            key: 'quick_easy',
            name: 'quick-easy',
        },
    ],
    de: [
        {
            key: 'no_waste',
            name: 'no-waste',
        },
        {
            key: 'app_control',
            name: 'app-control',
        },
        {
            key: 'day_and_night',
            name: 'day-and-night',
        },
        {
            key: 'diy_install',
            name: 'diy-install',
        },
        {
            key: 'upgradable',
            name: 'upgradable',
        },
    ],
    eu: [
        {
            key: 'no_waste',
            name: 'no-waste',
        },
        {
            key: 'app_control',
            name: 'app-control',
        },
        {
            key: 'day_and_night',
            name: 'day-and-night',
        },
        {
            key: 'diy_install',
            name: 'diy-install',
        },
        {
            key: 'upgradable',
            name: 'upgradable',
        },
    ],
};

export const singleAxisShopifyLinkMap = {
    uk: 'https://uk.ecoflow.com/products/single-axis-solar-tracker',
    de: 'https://de.ecoflow.com/products/single-axis-solar-tracker',
    fr: 'https://fr.ecoflow.com/products/single-axis-solar-tracker',
    it: 'https://it.ecoflow.com/products/single-axis-solar-tracker',
    es: 'https://es.ecoflow.com/products/single-axis-solar-tracker',
    eu: 'https://eu.ecoflow.com/products/single-axis-solar-tracker',
};

export const LIVE_STREAM_LINK = 'https://www.youtube.com/embed/PVqbCO2Wt1I';
